export default "__VITE_ASSET__BGgcRgcI__"